(function () {
  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const addUrl = (window.routes && window.routes.cart_add_url) || `${shopRoot}cart/add`;
  const cartUrl = (window.routes && window.routes.cart_url) || `${shopRoot}cart`;
  const mobileQuery = window.matchMedia('(max-width: 989px)');

  function setButtonState(button, label, disabled) {
    if (!button) return;
    button.innerHTML = label;
    button.disabled = Boolean(disabled);
    button.toggleAttribute('aria-disabled', Boolean(disabled));
    button.classList.toggle('is-loading', Boolean(disabled));
  }

  function submitNatively(form) {
    try {
      HTMLFormElement.prototype.submit.call(form);
    } catch (error) {
      window.location.assign(cartUrl);
    }
  }

  async function addProduct(form, cartDrawer) {
    const formData = new FormData(form);

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      const sectionIds = cartDrawer.getSectionsToRender().map((section) => section.id).join(',');
      formData.set('sections', sectionIds);
      formData.set('sections_url', window.location.pathname);
    }

    const response = await fetch(addUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: formData
    });

    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Impossibile aggiungere il prodotto.');
    }

    return data;
  }

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest && event.target.closest('.mk-cap-add-form');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const variantInput = form.querySelector('[name="id"]');
    if (!button || !variantInput || !variantInput.value || button.disabled) return;

    const originalLabel = button.innerHTML;
    const cartDrawer = document.querySelector('cart-drawer');
    const useMobileFlow = mobileQuery.matches;
    let productAdded = false;

    setButtonState(button, 'Aggiungo...', true);

    try {
      const data = await addProduct(form, useMobileFlow ? null : cartDrawer);
      productAdded = true;
      setButtonState(button, 'Aggiunto ✓', true);

      // Su telefono/tablet si va direttamente al carrello: non dipende dal drawer.
      if (useMobileFlow) {
        window.location.assign(cartUrl);
        return;
      }

      // Su desktop apre il drawer usando la risposta Shopify con le sezioni aggiornate.
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
        if (typeof cartDrawer.setActiveElement === 'function') {
          cartDrawer.setActiveElement(button);
        }
        cartDrawer.renderContents(data);
        window.setTimeout(() => setButtonState(button, originalLabel, false), 1400);
        return;
      }

      window.location.assign(cartUrl);
    } catch (error) {
      console.error('Card add-to-cart failed:', error);

      // Se l'aggiunta è riuscita ma è fallito solo il drawer, evita una seconda aggiunta.
      if (productAdded) {
        window.location.assign(cartUrl);
        return;
      }

      // Ultimo fallback: invio classico del form Shopify.
      setButtonState(button, 'Apro il carrello...', true);
      window.setTimeout(() => submitNatively(form), 120);
    }
  }, true);
})();
